export enum FilterSeparatorsEnum {
    SEMI_COLON = ';',
    COLON = ':',
    COMMA = ',',
    FULL_STOP = '.',
    IN_VALUE = '|'
}